import { SmallCollectionDisplay } from "@/features/common/components/SmallCollectionDisplay";
import { SmallProductDisplay } from "@/features/common/components/SmallProductDisplay";
import type { PriceAlertImage } from "@/features/priceAlerts/api/models/PriceAlertDetailsModel";

export type PriceAlertTargetDisplayProps = PriceAlertImage & {
	targetName: string;
	targetDescription: string;
	onClick?: () => void;
	className?: string;
};

export const PriceAlertTargetDisplay = (props: PriceAlertTargetDisplayProps) => {
	const {
		targetName,
		targetDescription,
		onClick,
		className
	} = props;

	if (props.targetType === "Variant") {
		return <SmallProductDisplay productName={targetName} fcId={targetDescription} imageUrl={props.targetImageUrl} onClick={onClick} />;
	}

	return <SmallCollectionDisplay name={targetName} description={targetDescription} image={props.targetImage} onClick={onClick} className={className} />;
};
